import { useEffect, useState } from 'react';

function prefereMovimentoReduzido(): boolean {
  if (typeof window === 'undefined') return false;
  if (typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Deslocamento em px seguindo a posição do mouse na janela, no máximo
 * `amplitude` px para cada lado de cada eixo (total de `amplitude * 2` px de
 * curso) — usado no mock do herói e nos blobs de fundo. Sempre `{0, 0}` sob
 * `prefers-reduced-motion: reduce`.
 */
export function useParallax(amplitude = 20): { x: number; y: number } {
  const [deslocamento, setDeslocamento] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (prefereMovimentoReduzido()) return undefined;

    function aoMoverMouse(evento: MouseEvent): void {
      const proporcaoX = evento.clientX / window.innerWidth - 0.5;
      const proporcaoY = evento.clientY / window.innerHeight - 0.5;
      setDeslocamento({
        x: proporcaoX * amplitude * 2,
        y: proporcaoY * amplitude * 2,
      });
    }

    window.addEventListener('mousemove', aoMoverMouse);
    return () => window.removeEventListener('mousemove', aoMoverMouse);
  }, [amplitude]);

  return deslocamento;
}
